module.exports = __webpack_public_path__ + "static/rocketlink-4b01444f1a07c1179312275e136ec566.png";